import React, { useState, useEffect } from "react";

import Form from "@Components/Form";
import eightAxios from "configs/axiosConfig";
import { GLOBAL_CONFIGURATION_URL } from "configs/constants";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import SaveIcon from "@material-ui/icons/Save";
import { useNotifyContext } from "@Components/Notify";

const detailURL = "/configuration/get-config/";

const SOSSetting = () => {
  const [loading, setLoading] = useState(false);
  const [sosSubmissionLimit, setSosSubmissionLimit] = useState(0);

  const setNotify = useNotifyContext();

  const fetchDetails = () => {
    setLoading(true);
    eightAxios
      .get(detailURL)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.sos_daily_submission_limit) {
            setSosSubmissionLimit(response.data.sos_daily_submission_limit);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
        }
        setLoading(false);
      });
  };

  const handleSubmit = (values, { setSubmitting }) => {
    setLoading(true);
    eightAxios
      .post(GLOBAL_CONFIGURATION_URL, values)
      .then(() => {
        setSosSubmissionLimit(values["sos_daily_submission_limit"]);
        setNotify({
          isOpen: true,
          message: "Successfully updated.",
          type: "success",
        });
        setLoading(false);
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          message: error.response.data.message,
          type: "error",
        });
        setSubmitting(false);
        setLoading(false);
      });
  };

  const initialValues = { sos_daily_submission_limit: sosSubmissionLimit };

  useEffect(() => {
    fetchDetails();
  }, []);

  const formFields = [
    {
      name: "sos_daily_submission_limit",
      type: "input",
      label: "Daily SOS Submission Limit",
      color: "primary",
      required: true,
      size: "medium",
      value: sosSubmissionLimit,
    },
  ];

  const formButtons = [
    {
      type: "submit",
      label: "Save",
      color: "primary",
      startIcon: <SaveIcon />,
    },
  ];

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  return (
    <div>
      <Form
        initialValues={initialValues}
        outerSubmitHandler={handleSubmit}
        formFields={formFields}
        formButtons={formButtons}
        formTitle="Daily SOS Submission Limit"
      />
    </div>
  );
};

export default SOSSetting;
